/**
 * Order filters component (order-filters.component.ts).
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2022-2024 Build Centrix
 */
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { IOrderFiltersModel } from '../../../interfaces/orders/order-interfaces';

@Component({
  selector: 'app-filters-dialog',
  templateUrl: './order-filters.component.html',
  styleUrls: ['./order-filters.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrderFiltersComponent {
  filtersChanged: Function;
  filters: BehaviorSubject<IOrderFiltersModel>;

  /**
   * Constructor
   * @since 4.71.0
   */
  constructor(
    public dialogRef: MatDialogRef<OrderFiltersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.filters = data.filters;
    this.filtersChanged = data.changesCallback;
  }

  /**
   * On Modal Dismiss
   * @since 4.31.0
   */
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
